import { SystemIcons } from '@almbrand/systemicons';
import { useThemeName } from 'hooks/useThemeName';
import styles from './PreviewButton.module.scss';

export const PreviewButton = () => {
	const themeName = useThemeName();

	return (
		<button className={styles.PreviewButton__button}>
			<span className={styles.PreviewButton__icon}>
				<SystemIcons
					themeName={themeName}
					icon={'arrow_right_bg'}
					width={'100%'}
					height={'100%'}
				/>
			</span>
		</button>
	);
};
